import { List as ChakraList, ListRootProps } from "@chakra-ui/react";

export type ListProps = ListRootProps & {
  spacing?: string | number; // v1/v2 - maps to gap in v3
};

export default function List({
  spacing,
  gap,
  ...props
}: ListProps): JSX.Element {
  // v1/v2 backward compatibility: map spacing to gap
  const gapValue = gap !== undefined ? gap : spacing;

  return <ChakraList.Root gap={gapValue} {...props} />;
}
